import { VOUCHERS_ROUTES } from '../../constants/_routes'
import vouchersTypes from '../../constants/vouchersTypes'
import { axios } from '../../services'

// INDEX
const campaign_select_request = () => {
  return {
    type: vouchersTypes.campaign_select.request
  }
}

const campaign_select_success = (response) => {
  return {
    type: vouchersTypes.campaign_select.success,
    payload: response.data
  }
}

const campaign_select = () => {
  return function (dispatch) {
    // Before Request
    dispatch(campaign_select_request())

    // Request
    axios.get(
      VOUCHERS_ROUTES.campaign_select
    ).then( response => {
      // success
      dispatch( campaign_select_success(response) )
    })
  }

}

export {
  campaign_select
}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/campaign_select.js